import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { FC } from 'react';

import { I18nProvider } from '../../hooks/contexts/i18n.context';
import { LoaderScreenProvider } from '../../hooks/contexts/loader-screen.context';
import { ModalProvider } from '../../hooks/contexts/modal.context';
import { ThemeProvider } from '../../hooks/contexts/theme.context';
import { UserProvider } from '../../hooks/contexts/user.context';
import { MembershipProvider } from './membership.context';
import { SsoProvider } from './sso.context';

type Props = {
  children: React.ReactNode
}

/**
 * MKT-483 — PostHog is SDK-owned via `@ingresse/awa-analytics-web`.
 *
 * `bootstrap` (called once in `main.tsx`) inits PostHog on the shared
 * `posthog-js` singleton, consent-aware. This provider only re-exposes that
 * SAME singleton as React context (`PHProvider client={posthog}`) WITHOUT
 * calling `posthog.init` again — the app's `posthog-js/react` hooks
 * (`usePostHog`, feature flags) keep working with a single instance and no
 * double-init.
 */
const Providers: FC<Props> = ({ children }) => {

  return (
    <LoaderScreenProvider>
      <PHProvider client={posthog}>
        <I18nProvider>
          <UserProvider>
            <MembershipProvider>
              <ThemeProvider>
                <ModalProvider>
                  <SsoProvider>
                    {children}
                  </SsoProvider>
                </ModalProvider>
              </ThemeProvider>
            </MembershipProvider>
          </UserProvider>
        </I18nProvider>
      </PHProvider>
    </LoaderScreenProvider>
  );
};

export default Providers;

